import { ScanText, TriangleAlert } from "lucide-react";

// Uma nota gerada sobre metade da conversa não vale o mesmo que uma sobre a
// conversa inteira. Sem este aviso as duas ficam indistinguíveis na tela.
const AnalysisCoverage = ({ analysis, className = "" }) => {
  if (!analysis || analysis.messagesAnalyzed === null
    || analysis.messagesAnalyzed === undefined) {
    return null;
  }

  const { messagesAnalyzed, messageCount, transcriptTruncated } = analysis;

  if (!transcriptTruncated) {
    return (
      <span
        className={`flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400 ${className}`}
      >
        <ScanText className="h-3 w-3" />
        IA leu as {messagesAnalyzed} mensagens
      </span>
    );
  }

  return (
    <span
      className={`flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 dark:bg-amber-900/30 dark:text-amber-300 ${className}`}
      title="A conversa não coube na janela de contexto do modelo: a IA avaliou apenas o trecho final, e a nota reflete só essa parte."
    >
      <TriangleAlert className="h-3 w-3" />
      Parcial: {messagesAnalyzed} de {messageCount} mensagens
    </span>
  );
};

export default AnalysisCoverage;
